import React, { useEffect, useContext } from 'react';
import LogoutContent from 'components/authentication/LogoutContent';
import Cookies from 'js-cookie';
import AuthCardLayout from 'layouts/AuthCardLayout';
import { AuthWizardContext } from '../../../context/Context';

const Logout = () => {
  const { setUser, setCompany } = useContext(AuthWizardContext);
  useEffect(() => {
    Cookies.remove(process.env.ACCESS_TOKEN);
    localStorage.removeItem(process.env.REACT_APP_USER_NAME);
    localStorage.removeItem('company');
    setUser({});
    setCompany(null);
  }, []);

  return (
    <AuthCardLayout>
      <div className="text-center">
        <LogoutContent layout="card" titleTag="h3" />
      </div>
    </AuthCardLayout>
  );
};

export default Logout;
